<template>
	<div id="contact-page">
		<div class="blurred-bg"></div>
		<div class="container">
			<div class="form" v-if="!isCargandoContacto">
				<div class="form-left">
					<div class="input-group">
						<label for="nombre">Nombre y apellido <span class="required">*</span></label>
						<input type="text" v-model="nombre" id="nombre" name="nombre">
					</div>
					<div class="input-group">
						<label for="email">Correo electrónico <span class="required">*</span></label>
						<input type="email" v-model="email" id="email" name="email">
					</div>
					<div class="input-group">
						<label for="telefono">Teléfono</label>
						<input type="text" v-model="telefono" id="telefono" name="telefono">
					</div>
					<div class="input-group">
						<label for="motivo">Motivo de contacto <span class="required">*</span></label>
						<select name="motivo" id="motivo" v-model="motivo">
							<option value="">(Seleccione un motivo)</option>
							<option value="I">Quiero organizar un evento con LineUp Tickets</option>
							<option value="P">Tuve un problema en el proceso de compra</option>
							<option value="S">Evento suspendido</option>
							<option value="O">Otro</option>
						</select>
					</div>
					<div class="input-group">
						<label for="mensaje">Mensaje <span class="required">*</span></label>
						<textarea name="mensaje" id="mensaje" v-model="mensaje" :placeholder="mensajePlaceholder"></textarea>
					</div>
					<span class="aclaracion-obligatorios">Los campos marcados con * son obligatorios</span>
					<button @click.prevent="contacto()">Enviar consulta</button>
				</div>
				<div class="form-right">
					<h1>¿Tenés alguna duda?</h1>
					<h1>Contactanos 👋</h1>
					<p>Si tienes alguna duda, inconveniente o sugerencia, puedes completar el formulario, o simplemente enviarnos un correo electrónico. Nuestro equipo te responderá a la brevedad.</p>
					<a class="form-right-row" href="mailto:hola@lineuptickets.com">
						<div class="row-left">
							<i class='bx bx-envelope'></i>
						</div>
						<div class="row-right">
							<span>Envianos un correo</span>
							<span class="value">hola@lineuptickets.com</span>
						</div>
					</a>
					<a class="form-right-row" href="https://instagram.com/lineuptickets" target="_blank">
						<div class="row-left">
							<i class='bx bxl-instagram'></i>
						</div>
						<div class="row-right">
							<span>Seguinos en Instagram</span>
							<span class="value">@lineuptickets</span>
						</div>
					</a>
					<a class="form-right-row" href="https://twitter.com/lineup_tickets" target="_blank">
						<div class="row-left">
							<i class='bx bxl-twitter'></i>
						</div>
						<div class="row-right">
							<span>Seguinos en Twitter</span>
							<span class="value">@lineup_tickets</span>
						</div>
					</a>
				</div>
			</div>
			<clip-loader class="contacto-loader" :color="'var(--color-primary)'" :size="'52px'" v-if="isCargandoContacto"></clip-loader>
		</div>
	</div>
</template>

<script>
	import axios from 'axios';
	import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

	export default {
		data(){
			return {
				isCargandoContacto: false,
				nombre: '',
				email: '',
				telefono: '',
				motivo: '',
				mensaje: '',
				mensajePlaceholder: ''
			}
		},
		components: {
			ClipLoader
		},
		metaInfo: {
			title: 'Contacto',
			titleTemplate: '%s 🎟 LineUp Tickets'
		},
		async mounted(){
			if(this.motivo === 'I'){
				this.mensajePlaceholder = '¡Cuéntanos acerca de tu idea!'
			} else if(this.motivo === 'P' || this.motivo === 'S') {
				this.mensajePlaceholder = 'Describe aquí tu inconveniente'
			} else {
				this.mensajePlaceholder = ''
			}
		},
		watch: {
			motivo(){
				if(this.motivo === 'I'){
					this.mensajePlaceholder = '¡Cuéntanos acerca de tu idea!'
				} else if(this.motivo === 'P' || this.motivo === 'S') {
					this.mensajePlaceholder = 'Describe aquí tu inconveniente'
				} else {
					this.mensajePlaceholder = ''
				}
			}
		},
		methods: {
			async contacto(){
				try {
					let isOk = true
					this.isCargandoContacto = true

					if(!this.nombre.trim()){
						isOk = false
						this.$store.dispatch('showError', 'Nombre y apellido no puede ser vacío')
					}

					if(isOk && !this.email.trim()){
						isOk = false
						this.$store.dispatch('showError', 'Correo electrónico no puede ser vacío')
					}

					if(isOk && !this.motivo){
						isOk = false
						this.$store.dispatch('showError', 'Debes seleccionar un motivo de contacto')
					}

					if(isOk && !this.mensaje.trim()){
						isOk = false
						this.$store.dispatch('showError', 'Mensaje no puede ser vacío')
					}

					if(isOk){
						let response = await axios.post('/WSContactoAlta', {
							ContactoNombreApellido: this.nombre.trim(),
							ContactoEmail: this.email.trim(),
							ContactoTelefono: this.telefono.trim(),
							ContactoMotivo: this.motivo,
							ContactoMensaje: this.mensaje
						});

						if(response.data.ErrorCod === 0){
							this.$store.dispatch('showSuccess', 'Mensaje enviado correctamente. Nos comunicaremos a la brevedad.')
							this.nombre = ''
							this.email = ''
							this.telefono = ''
							this.motivo = ''
							this.mensaje = ''
							this.mensajePlaceholder = ''
						} else {
							this.$store.dispatch('showError', response.data.ErrorDsc)
						}
					}
				} catch (error) {
					this.$store.dispatch('showError', 'Ocurrió un error. Vuelve a intentarlo.')

				} finally {
					this.isCargandoContacto = false
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	#contact-page{
		background-color: var(--color-white);
		@include flex(column, flex-start, flex-start);
		padding: 60px 0px;
		min-height: calc(100vh - 476px - var(--height-header));
		position: relative;

		.container{
			// max-width: 1160px;
			@include flex(column, flex-start, flex-start);

			h1{
				margin: 0;
				margin-bottom: 20px;
				font-family: var(--font-sora);
				font-size: 30px;
				line-height: 1em;
			}

			.contacto-loader{
				padding: 60px 0px;
				@include flex(row, center, center);
				width: 100%;
			}

			.form{
				width: 100%;
				@include flex(row, space-between, flex-start);

				.form-left{
					width: 55%;
					@include flex(column, flex-start, flex-start);
					padding: 40px;
				}

				.form-right{
					width: 45%;
					@include flex(column, flex-start, flex-start);
					padding: 40px;

					.form-right-row{
						width: 100%;
						@include flex(row, flex-start, center);
						margin: 20px 0px 0px 0px;
						padding: 10px 0px;
						text-decoration: none;
						color: var(--color-darker);

						.row-left{
							@include flex(row, center, center);
							background-color: var(--color-darker);
							border-radius: 99%;
							padding: 8px;
							width: 44px;
							height: 44px;
							margin-right: 16px;

							i{
								color: var(--color-white);
								font-size: 21px;
							}
						}

						.row-right{
							@include flex(column, center, flex-start);
							font-family: var(--font-sora);

							span{
								font-size: 14px;
								font-weight: var(--fw-300);
							}

							span.value{
								text-decoration: none;
								color: var(--color-darker);
								font-size: 18px;
								font-weight: var(--fw-600);
								line-height: 1.6em;
							}
						}
					}
				}

				.input-group{
					width: 100%;
					margin: 8px 0px 4px 0px;
					position: relative;
					@include flex(column, flex-start, flex-start);

					label {
						font-size: 13px;
						font-weight: var(--fw-600);
						margin-top: 0px;
						margin-bottom: 5px;
						line-height: 1em;
						@include flex(row, flex-start, center);

						span.required{
							color: var(--color-red-error);
							margin-left: 3px;
						}
					}

					input {
						-webkit-appearance: none;
						appearance: none;
						border: none;
						width: 100%;
						padding: 0px 36px 0px 14px;
						font-size: 14px;
						font-weight: var(--fw-400);
						line-height: 1.4em;
						width: 100%;
						border-radius: 8px;
						height: 44px;
						outline: none;
						box-shadow: rgb(176, 176, 176) 0px 0px 0px 1px inset;

						&::placeholder {
							color: #9aa5b5;
							opacity: 1;
						}

						&:-ms-input-placeholder {
							color: #9aa5b5;
						}

						&::-ms-input-placeholder {
							color: #9aa5b5;
						}

						&:focus-within {
							@include transition(all 0.2s);
							box-shadow: #222 0px 0px 0px 2px inset;

							&.form-input--error {
								box-shadow: var(--color-red-error) 0px 0px 0px 2px inset;
							}
						}

						&.form-input--error {
							box-shadow: var(--color-red-error) 0px 0px 0px 1px inset;
						}
					}

					select{
						@include sinApariencia();
						width: 100%;
						height: 44px;
						background-image: url('../assets/ChevronUpDown.svg');
						background-repeat: no-repeat;
						background-size: 18px;
						background-position: right 5px center;
						background-color: transparent;
						font-size: 14px;
						font-weight: var(--fw-400);
						line-height: 1.4em;
						outline: none;
						border: none;
						box-shadow: rgb(176, 176, 176) 0px 0px 0px 1px inset;
						padding: 0 14px;
						border-radius: 8px;
						padding: 0px 36px 0px 14px;
						cursor: pointer;

						&:focus{
							box-shadow: #222 0px 0px 0px 2px inset;
						}
					}

					textarea {
						-webkit-appearance: none;
						appearance: none;
						border: none;
						width: 100%;
						min-width: 100%;
						max-width: 100%;
						height: 150px;
						min-height: 150px;
						max-height: 150px;
						padding: 14px;
						font-size: 14px;
						font-weight: var(--fw-400);
						line-height: 1.4em;
						border-radius: 8px;
						outline: none;
						background-color: transparent;
						box-shadow: rgb(176, 176, 176) 0px 0px 0px 1px inset;

						&::placeholder {
							color: #9aa5b5;
							opacity: 1;
						}

						&:-ms-input-placeholder {
							color: #9aa5b5;
						}

						&::-ms-input-placeholder {
							color: #9aa5b5;
						}

						&:focus-within {
							@include transition(all 0.2s);
							box-shadow: #222 0px 0px 0px 2px inset;
						}
					}

					input:-webkit-autofill,
					input:-webkit-autofill:hover,
					input:-webkit-autofill:focus,
					textarea:-webkit-autofill,
					textarea:-webkit-autofill:hover,
					textarea:-webkit-autofill:focus,
					select:-webkit-autofill,
					select:-webkit-autofill:hover,
					select:-webkit-autofill:focus {
						border: none;
						-webkit-text-fill-color: var(--color-darker);
						box-shadow: rgb(176, 176, 176) 0px 0px 0px 1px inset,
							0 0 0px 1000px var(--color-white) inset;
						-webkit-box-shadow: rgb(176, 176, 176) 0px 0px 0px 1px inset,
							0 0 0px 1000px var(--color-white) inset;

						&:focus-within {
							box-shadow: rgb(34, 34, 34) 0px 0px 0px 2px inset,
								0 0 0px 1000px var(--color-white) inset;
						}
					}
				}

				button{
					@include flex(row, center, center);
					background-color: var(--color-darker);
					border: 1px solid var(--color-darker);
					border-radius: 8px;
					outline: none;
					padding: 0px 22px;
					color: var(--color-white);
					font-size: 14px;
					font-weight: var(--fw-600);
					font-family: var(--font-sora);
					line-height: 1.4em;
					letter-spacing: 1px;
					margin: 10px 0px 0px 0px;
					height: 44px;
					@include transition(all 0.2s);
					cursor: pointer;

					&:hover {
						background-color: var(--color-primary);
						border: 1px solid var(--color-darker);
						transform: translate(-0.25rem, -0.25rem);
						box-shadow: 0.25rem 0.25rem 0 var(--color-darker);
						color: var(--color-darker);
					}
				}
			}

			.aclaracion-obligatorios{
				width: 100%;
				margin-top: 8px;
				font-size: 12px;
				font-weight: var(--fw-400);
				line-height: 1.4em;
			}
		}

		.blurred-bg{
			--size: 450px;
			--speed: 30s;
			--easing: cubic-bezier(0.8, 0.2, 0.2, 0.8);

			position: absolute;
			height: var(--size);
			width: var(--size);
			opacity: 0.7;
			aspect-ratio: 1/1;
			right: 0;
			bottom: 100px;
			transform: translate(-50%, -50%);
			filter: blur(calc(var(--size) / 6));
			background-image: linear-gradient(var(--color-primary), var(--color-blue-link));
			animation: rotate var(--speed) var(--easing) alternate infinite;
			border-radius: 30% 70% 70% 30% / 30% 30% 70% 70%;

			@keyframes rotate {
				0% {
					transform: rotate(0deg);
				}
				100% {
					transform: rotate(360deg);
				}
			}
		}
	}

	@media screen and (max-width: 1400px){
		#contact-page{
			padding: 30px 0px;

			.container{
				padding-left: 24px;
				padding-right: 24px;

				.form{
					.form-left{
						padding: 20px;
					}

					.form-right{
						padding: 20px;
					}
				}
			}
		}
	}

	@media screen and (max-width: 950px){
		#contact-page{
			padding: 20px 0px;

			.blurred-bg{
				top: 250px;
				bottom: unset;
				opacity: 0.3;
			}

			.container{
				.form{
					@include flex(column, flex-start, center);
					.form-left{
						width: 80%;
						padding: 0px;
						order: 2;
					}

					.form-right{
						width: 80%;
						padding: 20px 0px;
						order: 1;
						margin-bottom: 20px;
					}
				}
			}
		}
	}

	@media screen and (max-width: 670px){
		#contact-page{
			.container{
				h1{
					font-size: 22px;
					margin-bottom: 14px;
				}

				p{
					font-size: 14px;
				}

				.form{
					.form-left{
						width: 100%;
					}

					.form-right{
						width: 100%;
						margin-bottom: 0px;

						.form-right-row{
							margin: 12px 0px 0px 0px;
							padding: 5px 0px;

							.row-left{
								margin-right: 12px;
								width: 38px;
								height: 38px;

								i{
									font-size: 18px;
								}
							}

							.row-right{
								span{
									font-size: 12px;

									&.value{
										font-size: 15px;
									}
								}
							}
						}
					}
				}
			}
		}
	}
</style>